export const TELEMETRY_APPLICATION = {
  PLATFORM: 'terra-platform',
  PORTAL: 'terra-portal',
} as const;
